export const VALUES = {
  // Duplicated from ui/packages/commit-attribution/test-utils/mock-data.ts.
  // Consider moving to a single shared location, given that ghost user is the
  // display-safe fallback for a null GraphQL User.
  ghostUser: {
    displayName: 'Ghost',
    login: 'ghost',
    avatarUrl: 'https://avatars.githubusercontent.com/ghost',
    path: '/ghost',
  },
  localStorageKeys: {
    issueComment: (prefix: string, issueId: string, commentId: string) =>
      `${prefix}-i${issueId}-c${commentId}.view-issue-comment`,
    issueNewComment: (prefix: string, issueId: string) => `${prefix}-i${issueId}.view-issue-comment-new`,
  },
}
